import { render, staticRenderFns } from "./DocumentToStore.vue?vue&type=template&id=bd843684&"
import script from "./DocumentToStore.vue?vue&type=script&lang=ts&"
export * from "./DocumentToStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports